module.exports = __webpack_public_path__ + "static/media/mouse-over.dd1e3047.wav";